import { ColumnRank, ColumnBib, ColumnName, ColumnWarnings, ColumnNoc, ColumnResult, ColumnPoints, ColumnRecords, ColumnQualification, ColumnExpander } from "components/common/TableColumns"

export function TableColumns(columnsAdded) {
    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ColumnResult({}),
            ColumnPoints({}),
            ColumnRecords({}),
            ColumnExpander({ type: 'extendedResults', expandIrm: true })
        ]
    )
}

export default TableColumns
